import React from 'react';

import PasswordResetRequestView from './PasswordResetRequest.view';

const PasswordResetRequest = (props) => <PasswordResetRequestView {...props} />;

export default PasswordResetRequest;
